import PropTypes from 'prop-types';
import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

function CouponExclusionBadge({ couponExclusionMessage }) {
    return couponExclusionMessage ? (
        <div
            data-automation-id="coupon-exclusion-badge"
            className={dt([
                'border-b',
                'border-solid',
                'border-gray-15',
                'italic',
                'text-sm',
                'leading-5',
                'text-gray-60',
                'pb-2',
            ])}
        >
            <p> {couponExclusionMessage}</p>
        </div>
    ) : null;
}

CouponExclusionBadge.propTypes = {
    couponExclusionMessage: PropTypes.string,
};

CouponExclusionBadge.defaultProps = {
    couponExclusionMessage: '',
};
export default CouponExclusionBadge;
